export interface HomeTestimonial {
  name: string;
  location: string;
  quote: string;
  rating: 1 | 2 | 3 | 4 | 5;
}

export const homeTestimonials: HomeTestimonial[] = [
  {
    name: "Sarah Flax",
    location: "Google Review",
    quote:
      "Can't say enough nice things about this company. The owner is so professional and his staff is wonderful.",
    rating: 5,
  },
  {
    name: "Bergen Thai Day Spa",
    location: "Google Review",
    quote:
      "They did an amazing job! All my clients love the color and the way they painted. They are very professional!",
    rating: 5,
  },
  {
    name: "Hanan Altaai",
    location: "Google Review",
    quote:
      "The first thing people say when they walk into our home is how incredible the paint work looks, and that alone says it all.",
    rating: 5,
  },
];
